import { Handle, Position, NodeResizer } from "@xyflow/react";
import { Select, Input } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import NodeNameInput from "./NodeNameInput";

const { Option } = Select;

const VOYCELL_SUPER_ADMIN_EMAIL = "info@voycell.com";

const TriggerNode = ({ data, selected }) => {
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });
  const userEmail = useSelector((s) => s.profile?.email || "");
  const isSuperAdmin = userEmail === VOYCELL_SUPER_ADMIN_EMAIL;

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#6366f1" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color="#6366f1" />
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <ThunderboltOutlined style={{ color: "#6366f1", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Trigger</strong>
      </div>

      <div
        className="nodrag"
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <NodeNameInput data={data} />
        <div style={{ marginBottom: 8 }}>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Starting Step</label>
          <Select
            value={data.triggerType || "keyword"}
            onChange={(v) => onChange("triggerType", v)}
            size="small"
            style={{ width: "100%" }}
          >
            <Option value="keyword">Text contains keyword</Option>
            <Option value="newContact">New contact first message</Option>
            <Option value="campaignReply">Campaign reply</Option>
            <Option value="manual">Manual trigger</Option>
            {isSuperAdmin && <Option value="newCompanyAdmin">New company registers</Option>}
          </Select>
        </div>

        {data.triggerType === "newCompanyAdmin" && (
          <div style={{
            background: "#f0fdf4",
            border: "1px solid #bbf7d0",
            borderRadius: 6,
            padding: "8px 10px",
            fontSize: 11,
            color: "#166534",
            lineHeight: 1.6,
          }}>
            Fires when a new company admin signs up.<br />
            <strong>Available variables:</strong><br />
            <code style={{ fontSize: 10 }}>{"{{reg_firstname}}"}</code> — first name<br />
            <code style={{ fontSize: 10 }}>{"{{reg_email}}"}</code> — email<br />
            <code style={{ fontSize: 10 }}>{"{{reg_phone}}"}</code> — phone number
          </div>
        )}

        {(data.triggerType === "keyword" || !data.triggerType) && (
          <>
            <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Match</label>
            <Select
              value={data.matchCriteria || "contains"}
              onChange={(v) => onChange("matchCriteria", v)}
              size="small"
              style={{ width: "100%", marginBottom: 8 }}
            >
              <Option value="contains">Contains</Option>
              <Option value="exact">Exact</Option>
            </Select>

            <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>
              Trigger keywords <span style={{ fontWeight: 400 }}>(comma-separated)</span>
            </label>
            <Input
              value={data.keyword || ""}
              onChange={(e) => onChange("keyword", e.target.value)}
              placeholder="e.g. hello, hi, hey"
              size="small"
            />
            <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 2 }}>
              Separate multiple keywords with commas
            </div>
          </>
        )}
      </div>

      <Handle type="source" position={Position.Right} style={{ background: "#6366f1" }} />
    </div>
  );
};

export default TriggerNode;
